import React from "react";
import { Text } from "rebass";

const P = ({ children }) => <Text p={"0.5em"}>{children}</Text>;

export default P;



// WEBPACK FOOTER //
// ./src/components/P.js